import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const faqData = [
  {
    q: "Hvor stor er DOLOMITI?",
    a: "DOLOMITI er den største modellen i LYKKE-kolleksjonen. Ytre mål: 240 × 220 × 250 cm. Grunnflate på cirka 52,8 m². Plass til 4 personer."
  },
  {
    q: "Hva er standard utstyr?",
    a: "Standard utstyr inkluderer HUUM Hive Mini 9 kW ovn, Or STS4-panel innvendig, Harvia stykker, LED-belysning innvendig og utvendig, termofuru oljebehandlet kledning, og LYKKE löyly PAKKE (bøtte, øse, termometer, timeglass)."
  },
  {
    q: "Kan jeg oppgradere til vedovn?",
    a: "Ja, HUUM HIVE Wood 13 kW er tilgjengelig som alternativ. Vedovn gir en autentisk badstuopplevelse med levende flamme, men krever skorstein og tilsyn under bruk."
  },
  {
    q: "Hvor lang er leveringstiden?",
    a: "Leveringstiden er typisk 6–8 uker fra kontraktinngåelse til ferdig badstuinstallasjon, avhengig av valgte tillegg og værforhold."
  },
  {
    q: "Hvilke tillegg kan jeg velge?",
    a: "Du kan tilpasse panel, ovn, gulv, dører, vindubehandling, belysning og lydanlegg. Alle tillegg tilpasses dine ønsker og behov."
  },
  {
    q: "Har dere leveranse og montering?",
    a: "Ja, leveranse og montering er inkludert i prisen. Vi håndterer alt fra produksjon til ferdig installasjon ved ditt hjem."
  }
];

export default function DolomitiFaqAccordion() {
  const [expanded, setExpanded] = useState(0);

  return (
    <div className="space-y-4">
      {faqData.map((item, i) => (
        <div key={i} className="border border-foreground/10 rounded-sm">
          <button
            onClick={() => setExpanded(expanded === i ? -1 : i)}
            className="w-full flex items-center justify-between px-6 py-4 hover:bg-secondary/10 transition-colors"
          >
            <span className="font-heading text-2xl font-light text-left">{item.q}</span>
             <ChevronDown size={20} className={`flex-shrink-0 text-foreground/40 transition-transform duration-300 ${expanded === i ? 'rotate-180' : ''}`} />
            </button>
            <AnimatePresence>
             {expanded === i && (
               <motion.div
                 initial={{ height: 0, opacity: 0 }}
                 animate={{ height: 'auto', opacity: 1 }}
                 exit={{ height: 0, opacity: 0 }}
                 transition={{ duration: 0.2 }}
                 className="overflow-hidden"
               >
                 <div className="px-6 py-4 bg-secondary/5 border-t border-foreground/10">
                   <p className="text-foreground/60 text-2xl leading-relaxed">{item.a}</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}